(function () {
  /* ================================================================
     Maison Thaevia — Content Pages shared JS
     The Maison · Bespoke · Appointment · The Archive
     ================================================================ */

  /* ---- Beliefs accordion (The Maison) ---- */
  document.querySelectorAll('.mt-belief__trigger').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.mt-belief');
      const isOpen = item.classList.contains('is-open');

      // Close all others
      document.querySelectorAll('.mt-belief.is-open').forEach((open) => {
        if (open !== item) open.classList.remove('is-open');
      });

      item.classList.toggle('is-open', !isOpen);
      trigger.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* ---- Segmented button groups (Appointment + Bespoke) ----
     Each group: data-target="<hidden-input-id>"
     Each button: data-value="<value>"
  ---- */
  document.querySelectorAll('.mt-seg-group[data-target]').forEach((group) => {
    const inputId = group.dataset.target;
    const hiddenInput = document.getElementById(inputId);

    group.querySelectorAll('.mt-seg-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        group.querySelectorAll('.mt-seg-btn').forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        if (hiddenInput) hiddenInput.value = btn.dataset.value;
      });
    });
  });

  /* ---- Appointment: pre-select from ?context= URL param ---- */
  const urlContext = new URLSearchParams(window.location.search).get('context');
  if (urlContext) {
    const targetBtn = document.querySelector(`.mt-seg-btn[data-value="${urlContext}"]`);
    if (targetBtn) {
      const group = targetBtn.closest('.mt-seg-group');
      if (group) {
        group.querySelectorAll('.mt-seg-btn').forEach((b) => b.classList.remove('is-active'));
        targetBtn.classList.add('is-active');
        const hiddenInput = document.getElementById(group.dataset.target);
        if (hiddenInput) hiddenInput.value = urlContext;
      }
    }
  }

  /* ---- Name echo (Appointment / Bespoke forms) ---- */
  const nameInput = document.getElementById('mt-form-name');
  const nameEcho  = document.getElementById('mt-form-name-echo');
  if (nameInput && nameEcho) {
    const defaultLabel = nameEcho.dataset.default || 'you';
    nameInput.addEventListener('input', () => {
      nameEcho.textContent = nameInput.value.trim() || defaultLabel;
    });
  }

  /* ---- Archive: journal category tabs ---- */
  document.querySelectorAll('.mt-arc-tab-btn').forEach((btn) => {
    btn.addEventListener('click', () => {
      const cat = btn.dataset.cat;

      document.querySelectorAll('.mt-arc-tab-btn').forEach((b) => {
        b.classList.toggle('is-active', b === btn);
      });

      document.querySelectorAll('.mt-arc-article-card').forEach((card) => {
        const matches = cat === 'All' || card.dataset.cat === cat;
        card.style.display = matches ? '' : 'none';
      });
    });
  });

  /* ---- Archive: edition detail expand/collapse ---- */
  document.querySelectorAll('.mt-arc-edition-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const edition = btn.closest('.mt-arc-edition');
      const isOpen  = edition.classList.contains('is-open');
      document.querySelectorAll('.mt-arc-edition.is-open').forEach((e) => e.classList.remove('is-open'));
      edition.classList.toggle('is-open', !isOpen);
    });
  });

  /* ---- Re-run on theme editor section reload ---- */
  document.addEventListener('shopify:section:load', () => {
    // reinit tabs
    document.querySelectorAll('.mt-arc-tab-btn.is-active').forEach((btn) => {
      btn.click();
    });
  });
})();
